import React, { useState } from 'react';
import PropTypes from 'prop-types';

import ExpandingTextarea from '@components/shared/expanding_textarea/main';

const NewAnnotation = ({ onSubmit }) => {
  const [value, setValue] = useState("");

  const handleSubmit = (event) => {
    event.preventDefault();
    onSubmit(value);
  };

  return (
    <form onSubmit={handleSubmit}>
      <h4>{t('Leave an annotation')}</h4>
      <ExpandingTextarea
        value={value}
        onChange={setValue}
        rows={3}
        maxRows={10}
        className="bf-textarea"
      />
      <button
        type="submit"
        className="button primary sm new-annotation-button"
        disabled={!value}
      >
        {t('Post')}
      </button>
    </form>
  );
};

NewAnnotation.propTypes = {
  onSubmit: PropTypes.func,
};

NewAnnotation.defaultProps = {
  onSubmit: () => {},
};

export default NewAnnotation;
